import { render } from "./EditAsli.vue?vue&type=template&id=2d6e6d6c"
import script from "./EditAsli.vue?vue&type=script&lang=js"
export * from "./EditAsli.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__